import { useState, useEffect, useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { SNACKBAR_SKIN } from 'components/shared/Snackbar';
import { showSnackbar } from 'hooks/useSnackbar';
import { getFontsThunk } from 'store/fonts/thunks';
import { itinerariesItemFontsSelector } from 'store/itinerariesItem/selectors';
import { updateItineraryLandingPageFontsThunk } from 'store/itinerariesItem/thunks';
import { getPageCustomFontsSelector } from 'store/page/selectors';
import { updateLandingPageFontsThunk } from 'store/page/thunks';
import { displayFonts } from 'utils/form/format';

function useCustomFonts(props) {
  const { isItinerariesItem } = props;
  const dispatch = useDispatch();
  const [fontsCollection, setFontsCollection] = useState([]);
  const [activeFontIds, setActiveFontIds] = useState([]);
  const [openFontsForm, setOpenFontsForm] = useState(false);
  const [loadingFont, setLoadingFont] = useState(false);
  const pageFonts = useSelector(getPageCustomFontsSelector);
  const itinerariesItemFonts = useSelector(itinerariesItemFontsSelector);
  const customFonts = isItinerariesItem ? itinerariesItemFonts : pageFonts;

  const handleSave = () => {
    const activeFonts = fontsCollection.filter((font) => activeFontIds.includes(font.id));
    const fontFilenames = activeFonts.map((font) => font.filename);

    try {
      if (isItinerariesItem) {
        dispatch(updateItineraryLandingPageFontsThunk({ customFonts: activeFonts }));
      } else {
        dispatch(updateLandingPageFontsThunk({ pageIndex: 0, customFonts: activeFonts }));
      }
      showSnackbar({ text: `${displayFonts(fontFilenames)} have been added` });
    } catch (e) {
      showSnackbar({ text: 'Oops! Something went wrong', type: SNACKBAR_SKIN.ERROR });
    }
  };

  const handleOpenFontsForm = () => setOpenFontsForm(true);
  const handleCloseFontsForm = () => setOpenFontsForm(false);
  const getFonts = useCallback(async () => {
    try {
      setLoadingFont(true);
      const result = await dispatch(getFontsThunk());
      if (result?.status === 200) {
        setFontsCollection(result?.data?.data || []);
      }
    } catch (e) {
      setLoadingFont(false);
    } finally {
      setLoadingFont(false);
    }
  }, [dispatch]);

  useEffect(() => {
    getFonts();
  }, [getFonts]);

  useEffect(() => {
    if (customFonts?.length > 0) {
      const activeIds = customFonts.map((font) => font.id);
      setActiveFontIds(activeIds);
    }
  }, [customFonts]);

  return {
    handleSave,
    fontsCollection,
    setFontsCollection,
    activeFontIds,
    setActiveFontIds,
    openFontsForm,
    handleOpenFontsForm,
    handleCloseFontsForm,
    getFonts,
    loadingFont,
  };
}

export default useCustomFonts;
